import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews';

// Include required dependencies.
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// Include Concord module dependencies.
require('@galaxy/modules/Core/resources/js/sentry/withoutVue.js');
require('@galaxy/modules/Core/resources/js/View.js');
//require('@galaxy/modules/Core/resources/js/vue.js');
require('@galaxy/modules/Canvas/resources/js/bootstrap.website.js');
require('@galaxy/modules/Website/resources/js/partials/cookies.js');
require('@galaxy/modules/Website/resources/js/common/statistics.js');

// TODO Medium: Not a real overwrite anymore. Can we hook into require() to be able to overwrite files?
require('./galaxy/website/partials/menu');

// Load app specific JS.
// TODO Concord: How to overwrite? Does 2nd arg work?
AutoloadViews.load('website', require.context('./website/', true, /.(js|vue)$/), require.context('./galaxy/website/', true, /.(js|vue)$/));
AutoloadViews.load('components.website', require.context('./../components/website/', true, /.(js|vue)$/));
AutoloadViews.load('modules.website', require.context('./../../app/Modules/Partners/resources/components/website/', true, /.(js|vue)$/));
